import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {ClearTimezonesSuccessAction, LoadTimezonesSuccessAction, timezonesActionTypes, UpdateTimezonesSuccessAction} from '../actions/timezones';
import {Timezone} from '../models/timezone';
import {SEPARATOR_SELECT} from '../consts';

export interface TimezonesState {
  // tslint:disable-next-line:no-any
  array: any[];
}

const initialState: TimezonesState = {
  array: []
};

export function timezonesReducer(state: TimezonesState = initialState, action: Action): TimezonesState {
  switch (action.type) {
    case timezonesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case timezonesActionTypes.UPDATE:
      return handleUpdateSuccessAction(state, action);
    case timezonesActionTypes.CLEAR:
      return handleLoadClearActions(state, action);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: TimezonesState, action: LoadTimezonesSuccessAction): TimezonesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}
function handleUpdateSuccessAction(state: TimezonesState, action: UpdateTimezonesSuccessAction): TimezonesState {
  const newState = _.clone(state);
  const separator = {'name': SEPARATOR_SELECT, 'ianaCode': '' , 'id':  ''};
  const indexTimezone =  _.findIndex( newState.array, function (o: Timezone): boolean { return o.name === SEPARATOR_SELECT; });
  const arraySmall = [];
  for (let i = 0; i < indexTimezone; i++) {
    arraySmall.push(newState.array[i])
  }
  newState.array = _.concat(newState.array , arraySmall);
  newState.array = _.drop(newState.array, (indexTimezone + 1));
  // @ts-ignore
  newState.array = _.concat(
    {'name': '', 'ianaCode': ((action.payload && action.payload.length > 0) ? action.payload[0].value : null) , 'id':  ''} , separator,
    _.orderBy(newState.array, ['ianaCode'], ['asc']));
  newState.array = _.uniqBy(newState.array , 'ianaCode');
  return newState;
}

function handleLoadClearActions(state: TimezonesState, action: ClearTimezonesSuccessAction): TimezonesState {
  const newState: TimezonesState = {
    array: []
  };
  return newState;
}

export const timezonesSelectors = {
  array: (state: TimezonesState) => _.get(state, 'array', []),
  getTimezonesByIanaCode: (state: TimezonesState, props: string) => {
    return state.array.filter((timeZone: Timezone) => timeZone.ianaCode === props);
  }
};
